import "./sass/index.scss"

import "./js/index"
console.log('this is public file public.js');